<template>
  <payment-link-layout :hideSecurityWarning="true">
    <template v-slot:content>
      <asset-v3
        class="sad-bag-icon"
        dir="abstract"
        name="sad-bag.svg"
      />
      <h1 class="h1 gray-900 mt-12">
        Crédito não disponível no momento
      </h1>

      <p class="body-regular gray-900 mt-20">
        Ainda não temos crédito disponível para o seu perfil.
      </p>
      <br>
      <p class="body-regular gray-900 mb-20">
        Para uma nova análise de crédito, aguarde 60 dias e tente novamente em nosso site.
      </p>
      <span class="body-regular mb-20"><a href="https://ajuda.parcelex.com.br/credito-indisponivel" target="_blank">Entenda o porquê</a></span>
    </template>
  </payment-link-layout>
</template>

<script>
import AssetV3 from '@/components/common/AssetV3.vue';
import PaymentLinkLayout from '../layout/PaymentLinkLayout.vue';

export default {
  name: 'PaymentLinkCreditDenied',
  components: {
    PaymentLinkLayout,
    AssetV3,
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .h1 {
    font-size: 28px;
    line-height: 36px;

    @media (min-width: $breakpoint-large) {
      font-size: 24px;
      line-height: 32px;
    }
  }

  .sad-bag-icon {
    padding-top: 36px;
  }
</style>
